import { render, staticRenderFns } from "./receivableComponent.vue?vue&type=template&id=5a539472&scoped=true&"
import script from "./receivableComponent.vue?vue&type=script&lang=js&"
export * from "./receivableComponent.vue?vue&type=script&lang=js&"
import style0 from "./receivableComponent.vue?vue&type=style&index=0&id=5a539472&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a539472",
  null
  
)

export default component.exports